(function () {
  if (window.__cbmInit) return;
  window.__cbmInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = null;

  function initReveals(root) {
    var els = (root || document).querySelectorAll('.cbm-reveal:not(.cbm-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) {
      els.forEach(function (el) { el.classList.add('cbm-visible'); });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('cbm-visible'); observer.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }
    els.forEach(function (el) { observer.observe(el); });
  }

  function initHero(root) {
    (root || document).querySelectorAll('.cbm-hero').forEach(function (hero) {
      hero.style.setProperty('--cbm-hero-alto', hero.offsetHeight + 'px');
    });
  }

  function initGalerias(root) {
    (root || document).querySelectorAll('[data-cbm-galeria]').forEach(function (gal) {
      if (gal.dataset.cbmInit) return;
      gal.dataset.cbmInit = '1';
      var dlg = gal.querySelector('dialog');
      if (!dlg || typeof dlg.showModal !== 'function') return;
      var img = dlg.querySelector('img');
      var h = dlg.querySelector('h3');
      var p = dlg.querySelector('p');
      var tag = dlg.querySelector('.cbm-galeria__tag');
      gal.querySelectorAll('[data-cbm-foto]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          img.removeAttribute('width');
          img.removeAttribute('height');
          img.src = btn.dataset.cbmFoto;
          img.alt = btn.dataset.cbmAlt || '';
          h.textContent = btn.dataset.cbmTitulo || '';
          p.textContent = btn.dataset.cbmTexto || '';
          if (tag) { tag.textContent = btn.dataset.cbmTag || ''; tag.hidden = !btn.dataset.cbmTag; }
          dlg.showModal();
        });
      });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
      var cerrar = dlg.querySelector('.cbm-lightbox__cerrar');
      if (cerrar) cerrar.addEventListener('click', function () { dlg.close(); });
    });
  }

  function initMateriales(root) {
    (root || document).querySelectorAll('[data-cbm-materiales]').forEach(function (sec) {
      if (sec.dataset.cbmInit) return;
      sec.dataset.cbmInit = '1';
      var tabs = Array.prototype.slice.call(sec.querySelectorAll('[data-cbm-mat-tab]'));
      function activar(i, foco) {
        tabs.forEach(function (t, k) {
          var on = k === i;
          t.classList.toggle('is-activo', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          if (on && foco) t.focus();
        });
        sec.querySelectorAll('[data-cbm-mat-card]').forEach(function (c) { c.hidden = c.dataset.cbmMatCard !== String(i); });
        sec.querySelectorAll('[data-cbm-mat-fondo]').forEach(function (f) { f.classList.toggle('is-activo', f.dataset.cbmMatFondo === String(i)); });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { activar(i); });
        t.addEventListener('keydown', function (e) {
          var n = tabs.length, d = 0;
          if (e.key === 'ArrowDown' || e.key === 'ArrowRight') d = 1;
          if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') d = -1;
          if (d) { e.preventDefault(); activar((i + d + n) % n, true); }
        });
      });
      sec.addEventListener('shopify:block:select', function (e) {
        var idx = tabs.findIndex(function (t) { return t.contains(e.target) || t === e.target; });
        if (idx > -1) activar(idx);
      });
    });
  }

  function valor(form, name) {
    var el = form.elements[name];
    if (!el) return '';
    if (el instanceof RadioNodeList) return (el.value || '').trim();
    return (el.value || '').trim();
  }

  function construirMensaje(form) {
    var lineas = [];
    var saludo = form.dataset.saludo || 'Hola, me gustaría pedir un presupuesto.';
    lineas.push(saludo);
    lineas.push('');
    var campos = [
      ['nombre', 'Nombre'],
      ['tipo', 'Tipo de encargo'],
      ['idea', 'Mi idea / necesidad'],
      ['medidas', 'Medidas aproximadas'],
      ['cantidad', 'Cantidad'],
      ['colores', 'Colores'],
      ['fecha', 'Lo necesito para'],
      ['ciudad', 'Envío a']
    ];
    campos.forEach(function (c) {
      var v = valor(form, c[0]);
      if (v) lineas.push(c[1] + ': ' + v);
    });
    return lineas.join('\n');
  }

  function initPresupuesto(root) {
    (root || document).querySelectorAll('[data-cbm-presupuesto]').forEach(function (form) {
      if (form.dataset.cbmInit) return;
      form.dataset.cbmInit = '1';
      var error = form.querySelector('.cbm-form__error');
      form.addEventListener('submit', function (e) { e.preventDefault(); });
      form.querySelectorAll('[data-cbm-enviar]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          if (!valor(form, 'idea')) {
            if (error) error.classList.add('is-on');
            var idea = form.elements['idea'];
            if (idea) idea.focus();
            return;
          }
          if (error) error.classList.remove('is-on');
          var msg = construirMensaje(form);
          var canal = btn.dataset.cbmEnviar;
          var url;
          if (canal === 'whatsapp') {
            var tel = (form.dataset.whatsapp || '').replace(/[^0-9]/g, '');
            url = 'https://wa.me/' + tel + '?text=' + encodeURIComponent(msg);
            window.open(url, '_blank', 'noopener');
          } else {
            var asunto = form.dataset.asunto || 'Solicitud de presupuesto';
            var nombre = valor(form, 'nombre');
            if (nombre) asunto += ' - ' + nombre;
            url = 'mailto:' + (form.dataset.email || '') + '?subject=' + encodeURIComponent(asunto) + '&body=' + encodeURIComponent(msg);
            window.location.href = url;
          }
        });
      });
    });
  }

  function initTodo(e) {
    var root = e && e.target && e.target.querySelectorAll ? e.target : document;
    initReveals(root);
    initHero(root);
    initGalerias(root);
    initPresupuesto(root);
    initMateriales(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initTodo(); });
  } else {
    initTodo();
  }
  document.addEventListener('shopify:section:load', initTodo);
})();
